// extracted by extract-css-chunks-webpack-plugin
module.exports = {"col_box":"col_box-3E8Fih8A","col_navlist":"col_navlist-3M6S3Nye"};